/* Won't Miss Garage core v0.1.0
   Reads the config JSON from layout/theme.liquid, wires the nav, vehicle selector, mascot panel and a fail-open reveal.
   Everything here is optional polish: the page works with this file missing. */
(function () {
  'use strict';

  var WMG = window.WMG = window.WMG || {};
  var cfg = {};
  try {
    var cfgEl = document.getElementById('WMGConfig');
    cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  } catch (e) { cfg = {}; }
  WMG.config = cfg;
  WMG.version = cfg.version || '0.1.0';

  WMG.qs = function (sel, root) { return (root || document).querySelector(sel); };
  WMG.qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Money formatting from a cents integer, using the shop currency. */
  WMG.money = function (cents, currency) {
    var amount = (Number(cents) || 0) / 100;
    var code = currency || cfg.currency || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount);
    } catch (e) {
      return code + ' ' + amount.toFixed(2);
    }
  };

  /* Escape text for innerHTML use. */
  WMG.esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* Read all named inputs of a form into a flat object. contact[Field] becomes Field. */
  WMG.formData = function (form) {
    var out = {};
    WMG.qsa('input, select, textarea', form).forEach(function (el) {
      if (!el.name) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      var key = el.name.replace(/^contact\[(.+)\]$/, '$1').replace(/^form_type$|^utf8$/, '');
      if (!key) return;
      out[key] = el.value;
    });
    return out;
  };

  /* ---------- Header nav ---------- */
  var header = WMG.qs('[data-wmg-header]');
  var burger = WMG.qs('[data-wmg-nav-toggle]');
  if (header && burger) {
    burger.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }
  WMG.qsa('[data-wmg-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var item = btn.closest('.wmg-nav__item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Vehicle selector: each option value is a collection URL filtered by tag ---------- */
  WMG.qsa('[data-wmg-vehicle-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      if (sel.value) window.location.href = sel.value;
    });
  });

  /* ---------- Mascot auction panel: rotate through lines ---------- */
  WMG.qsa('[data-wmg-panel]').forEach(function (panel) {
    var lineEl = WMG.qs('[data-wmg-panel-line]', panel);
    var src = WMG.qs('[data-wmg-panel-lines]', panel);
    var lines = [];
    try { lines = JSON.parse(src ? src.textContent : '[]'); } catch (e) { lines = []; }
    lines = lines.map(function (l) { return String(l).trim(); }).filter(Boolean);
    if (!lineEl || lines.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % lines.length;
      panel.classList.remove('is-swapping');
      void panel.offsetWidth;
      lineEl.textContent = lines[i];
      panel.classList.add('is-swapping');
    }, 3600);
  });

  /* ---------- Fail-open reveal: elements start at 0.85 opacity and get polished to 1 ---------- */
  if (cfg.reveal !== false && 'IntersectionObserver' in window) {
    var targets = WMG.qsa('[data-wmg-card], .wmg-tile, .wmg-post, .wmg-steps__item');
    targets.forEach(function (el) { el.classList.add('wmg-reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('on'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -5% 0px' });
    targets.forEach(function (el) { io.observe(el); });
    /* Safety net: whatever is still un-revealed after 3s gets revealed anyway. */
    setTimeout(function () { targets.forEach(function (el) { el.classList.add('on'); }); }, 3000);
  }

  /* ---------- Product page: thumbnails swap the stage, variant select updates the price ---------- */
  var stage = WMG.qs('[data-wmg-stage]');
  if (stage) {
    WMG.qsa('[data-wmg-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-wmg-thumb');
        var tpl = WMG.qs('template[data-wmg-media-tpl="' + id + '"]');
        if (!tpl) return;
        stage.innerHTML = '';
        stage.appendChild(tpl.content.cloneNode(true));
        WMG.qsa('[data-wmg-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (WMG.media && WMG.media.refresh) WMG.media.refresh(stage);
      });
    });
    var variantSel = WMG.qs('[data-wmg-variant-select]');
    var priceEl = WMG.qs('[data-wmg-price]');
    if (variantSel && priceEl) {
      variantSel.addEventListener('change', function () {
        var opt = variantSel.options[variantSel.selectedIndex];
        if (opt && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
      });
    }
  }

  /* ---------- Cart count refresh after any Shopify add-to-cart form posts (best effort) ---------- */
  WMG.refreshCartCount = function () {
    var el = WMG.qs('[data-wmg-cart-count]');
    if (!el || !window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      el.textContent = cart.item_count;
    }).catch(function () {});
  };
})();
